import { render, staticRenderFns } from "./ApplyPlan.vue?vue&type=template&id=65d9e9e3&"
import script from "./ApplyPlan.vue?vue&type=script&lang=js&"
export * from "./ApplyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports